import * as React from 'react';
import { Box, Grid } from '@mui/material';
import { VendorMapSelectControl } from './VendorMapSelect';
export function VendorInformation(props) {

	const lastRowStyle = {
		paddingLeft: '5px',
		paddingRight: '10px',
		marginTop: 0
	}
	const editorType_changehandler = React.useCallback((event) => {
		props.setEditorType(event.target.value)
	})

	const additionalVendorIdentifierFieldData = React.useMemo(() => {
		const fd = props.fieldData || {};
		const records = fd.Records || [];

		const ocrRecords = records.filter(r => r.Key !== "InvoiceContains");
		const filteredOcrRecords = ocrRecords.filter(r => {
			if (!r) return false;
			if (r.Valuetype === "date" || r.Valuetype === "currency") return false;

			const v = (r.Value ?? '').toString().trim();
			if (!v) return false;
			if (/^[0-9\-,.\/\s]+$/.test(v)) return false;

			return true;
		});

		const hasOcrInvoiceContains = records.some(r => r.Key === "InvoiceContains");

		let finalRecords = filteredOcrRecords;

		if (hasOcrInvoiceContains) {
			const invoiceContainsRecord = records.find(r => r.Key === "InvoiceContains");
			finalRecords = [invoiceContainsRecord, ...finalRecords];
		}
		else {
			finalRecords = [
				{ Key: "InvoiceContains", Value: "Invoice Contains", Valuetype: "string" },
				...finalRecords
			];
		}

		return {
			Records: finalRecords
		};

	}, [props.fieldData]);

	const isadditionalVendorIdentifierCustom =
		props.mappedFields?.additionalVendorIdentifier?.mappedField === 'InvoiceContains';

	return (<><div className="mf-12">
		<h2>Vendor Information</h2>
		<Box>
			<Grid container spacing={props.style.mainRowSpacing} style={props.style.mainRowStyle}>
				<Grid item xs={props.style.cellOneWidth} sx={props.style.cellOneStyle}><label>ERP Vendor/Site:</label></Grid>
				<Grid item xs={8}>

					<div className='vendorInputWrapper'>
						<input type="text" value={props.mappedFields?.vendor?.value} disabled name="modelTag" placeholder="Vendor/Site" />
						{!props.isChangingNotAllowed ? <img src="images/images-invoicemodelsetup/search-icon.png"
							style={{ cursor: 'pointer', zIndex: 'auto' }}
							onClick={props.search_clickHandler}
							alt="Search Vendor" />: <></>}
					</div>
				</Grid>
			</Grid>
			<Grid container spacing={props.style.mainRowSpacing} style={{ ...props.style.mainRowStyle, paddingBottom: 0 }}>
				<Grid item xs={props.style.cellOneWidth} sx={props.style.cellOneStyle}><label>Vendor Identifier:</label></Grid>
				<Grid item xs={4}>
					<input type="text" name="modelName" value={props.mappedFields?.vendorIdentifier?.value} disabled placeholder="Vendor Identifier" />
				</Grid>
				<Grid container item xs={4} spacing={props.style.mainRowSpacing} style={{ ...props.style.mainRowStyle, paddingRight: 0 }} >
					<Grid item xs={6} style={{ textAlign: 'right' }}><label>Scanned Currency:</label></Grid>
					<Grid item xs={6}>
						<input type="text" name="modelTag" value={props.mappedFields?.currencyCode?.value} disabled placeholder="Currency" />
					</Grid>
				</Grid>
			</Grid>
			{props.advanceEdit && (
			<Grid
				container
				spacing={props.style.mainRowSpacing}
				style={{ ...props.style.mainRowStyle, paddingBottom: 0 }}
			>
				<Grid item xs={props.style.cellOneWidth} sx={props.style.cellOneStyle}>
					<label>Additional Vendor Identifier:</label>
				</Grid>

					<Grid item xs={4}>
						<VendorMapSelectControl
							style={props.style}
							fieldData={additionalVendorIdentifierFieldData}
							value={props.mappedFields?.additionalVendorIdentifier}
							recordType={'Records'}
							type={'string'}
							fieldInfo={{ type: 'string' }}
							readOnly={props.readOnly}
							controlKey={'additionalVendorIdentifier'}
							regex={props.regex}
							onChange={(event) =>
								props.field_changehandler({
									event: event,
									value: 'additionalVendorIdentifier'
								})
							}
						/>
					</Grid>

				<Grid item xs={4}>
					<input
						type="text"
						value={props.mappedFields?.additionalVendorIdentifier?.value || ''}
						disabled={!props.advanceEdit || !isadditionalVendorIdentifierCustom}
						placeholder="Additional Vendor Identifier"
						onChange={(e) =>
							props.field_changehandler({
								event: { target: { value: e.target.value } },
								value: 'additionalVendorIdentifier'
							})
						}
					/>
				</Grid>
			</Grid>
			)}
			
			<Grid container spacing={props.style.mainRowSpacing} item justifyContent={props.modelDefId !== 3 ? '' : 'end' } alignItems={'center'} style={lastRowStyle}>
				{props.modelDefId !== 3 && <><Grid item xs={props.style.cellOneWidth} sx={props.style.cellOneStyle}><label>Level Of Detail:</label></Grid>
				 <Grid item xs={4}>
					<Grid container>
							<Grid item xs={12}>
								<input id={'rdVendorInformationSummary'} disabled={props.readOnly} type="radio" style={{ marginTop: "7px" }} onChange={editorType_changehandler} checked={props.editorType === 'summary'} name='editorType' value='summary' />
							<label htmlFor="rdVendorInformationSummary" style={{ paddingTop: "6px", verticalAlign: "top", marginTop: 0 }} >Summary</label>&nbsp;&nbsp;
								<input id={'rdVendorInformationDetail'} type="radio" disabled={props.readOnly} style={{ marginTop: "7px" }} onChange={editorType_changehandler} checked={props.editorType === 'detail'} name='editorType' value='detail' />
								<label htmlFor="rdVendorInformationDetail" style={{ paddingTop: "6px", verticalAlign: "top", marginTop: 0 }} >Detail</label>
						</Grid>
					</Grid>
				</Grid></>}
				{<Grid container item xs={4} spacing={props.style.mainRowSpacing} style={{ ...props.style.mainRowStyle, paddingRight: 0, paddingBottom: 0 }} >
					<Grid item xs={6} style={{ textAlign: 'right' }}><label htmlFor="chkAdvanceEdit" style={{ paddingTop: "6px", verticalAlign: "top", marginTop: 0 }} >Advance Edit</label></Grid>
					<Grid item xs={6}>
						<input id={'chkAdvanceEdit'} type="checkbox" style={{ marginTop: "9px" }} onChange={props.advanceEdit_changeHandler} checked={props.advanceEdit} />
					</Grid>
				</Grid>}
			</Grid>
		</Box>

	</div>
	</>);
}